import { db } from './config';
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  serverTimestamp
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { functions } from './config';

export async function findUserByEmail(email) {
  const q = query(collection(db, 'users'), where('email', '==', email));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

export async function createManagedUser({ email, displayName, createdBy, role = 'user', initialCredits = 0 }) {
  const ref = await addDoc(collection(db, 'managedUsers'), {
    email: email.trim().toLowerCase(),
    displayName: displayName || '',
    role: role === 'admin' ? 'admin' : 'user',
    initialCredits: Number(initialCredits) || 0,
    createdBy,
    createdAt: serverTimestamp()
  });
  return { id: ref.id };
}

export async function listManagedUsers(createdBy) {
  const q = query(collection(db, 'managedUsers'), where('createdBy', '==', createdBy));
  const snap = await getDocs(q);
  const items = [];
  snap.forEach(docSnap => items.push({ id: docSnap.id, ...docSnap.data() }));
  return items;
}

export async function deleteManagedUser(managedUserId) {
  await deleteDoc(doc(db, 'managedUsers', managedUserId));
  return { success: true };
}

export async function grantAdminAccess(userId) {
  const userRef = doc(db, 'users', userId);
  const userSnap = await getDoc(userRef);
  if (!userSnap.exists()) throw new Error('User not found');
  await setDoc(userRef, { isAdmin: true }, { merge: true });
  return { success: true };
}

export async function revokeAdminAccess(userId) {
  const userRef = doc(db, 'users', userId);
  const userSnap = await getDoc(userRef);
  if (!userSnap.exists()) throw new Error('User not found');
  await setDoc(userRef, { isAdmin: false }, { merge: true });
  return { success: true };
}

export async function setUserCreditsById(userId, credits) {
  const userRef = doc(db, 'users', userId);
  const userSnap = await getDoc(userRef);
  if (!userSnap.exists()) throw new Error('User not found');
  await setDoc(userRef, { credits: Number(credits) || 0, updatedAt: serverTimestamp() }, { merge: true });
  return { success: true };
}

export async function adminCreateUserWithPassword({ email, password, displayName, role = 'user', initialCredits = 0 }) {
  const callable = httpsCallable(functions, 'adminCreateUser');
  const res = await callable({ email, password, displayName, role, initialCredits });
  return res.data;
} 